import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./Styles/App.css";
import { APPRoutes } from "./Utils/Route";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./Context/AuthContext";
import { ThemeProvider } from "./Context/ThemeContext";
import ProtectedRoute from "./Context/ProtectedRoute";
import Layout from "./Components/Layout";
import Restricted from "./Components/Restricted/Restricted";
import NotFound from "./Components/ErrorPages/NotFound";
import ServiceUnavailable from "./Components/ErrorPages/ServiceUnavailable";
import ServiceUnavailableWatcher from "./Components/ErrorPages/ServiceUnavailableWatcher";
import { publicRoutes, protectedRoutes } from "./Utils/RouteConfig";
import useSecurityRestrictions from "./Utils/useSecurityRestrictions";
import InternetStatusToast from "./Components/Common/InternetStatusToast";

function App() {
  //  useSecurityRestrictions();

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <InternetStatusToast />

          <Routes>
            {publicRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}

            <Route path={APPRoutes.RESTRICTED} element={<Restricted />} />
            <Route path={APPRoutes.SERVICE_UNAVAILABLE} element={<ServiceUnavailable />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                {protectedRoutes.map((route) => {
                  if (route.requiredPermission || route.requiredRoles) {
                    return (
                      <Route
                        key={route.path}
                        element={<ProtectedRoute requiredPermission={route.requiredPermission} requiredRoles={route.requiredRoles} />}
                      >
                        <Route path={route.path} element={route.element} />
                      </Route>
                    );
                  }

                  return <Route key={route.path} path={route.path} element={route.element} />;
                })}
              </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
          <ServiceUnavailableWatcher />
          <ToastContainer position="top-right" autoClose={3000} theme="colored" />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App;